import { httpClient } from "../../app/data-service"

export const getContactMd$ = async () => {
    const result = await httpClient.get('getMarkdown/kapcsolat').catch((error) => Promise.reject(error));
    return Promise.resolve(result.data.data.md);
}